/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'auth-settings';
const componentName = 'auth-mapping-profile-modal';
const prefix = `${moduleName}.${componentName}`;

export const modalTitleEdit = `${prefix}.modalTitleEdit`;
export const modalTitleNew = `${prefix}.modalTitleNew`;
export const sectionTitleRules = `${prefix}.sectionTitleRules`;
export const sectionTitleLabelFilters = `${prefix}.sectionTitleLabelFilters`;
export const filtersLabel = `${prefix}.filtersLabel`;
export const typeDropdownPlaceholder = `${prefix}.typeDropdownPlaceholder`;
export const allowUnlabelledAccessLabel = `${prefix}.allowUnlabelledAccessLabel`;

export const ENGLISH = {
    [modalTitleEdit]: 'Edit Auth Mapping Profile',
    [modalTitleNew]: 'Create Auth Mapping Profile',
    [sectionTitleRules]: 'Rules',
    [sectionTitleLabelFilters]: 'Label Filters',
    [filtersLabel]: 'Filters ({0})',
    [typeDropdownPlaceholder]: 'Select Type',
    [allowUnlabelledAccessLabel]: 'Allow unlabelled access',
};
